import React from 'react';
import journeyArrow from '../../assets/img/journeyArrow.svg';
import Button from '../button/Button';
import { useInView } from 'react-intersection-observer';

function OfferItemCard({t,img,description,text,handlerSelectModal}) {
  const{ ref,inView } = useInView({
    threshold:0,
  })
  return (
    <div ref={ref} className={`offer-item animation ${inView ? 'show-ofer-card': ""}`}>
      <img src={img} alt="offer card"/>
      <div className="offer-context">
        <div className="context-capture">
          {description}
        </div>
        <div className="context-text">
          {text}
        </div>
        <div className="offer-link" >
          <Button text = {t("button_start_your_journey")} handlerSelectModal={handlerSelectModal}/>
          <img src={journeyArrow} alt="offer link"/>
        </div>
      </div>
    </div>
  );
}

export default OfferItemCard;